// Installable app (PWA). The switch lives on the server (PWA_MODE: "0" off · "admin" admins + observers · "1" everyone):
// GET /api/pwa/status says whether this user may install; the manifest link in index.html is credentialed, so the
// browser only sees a manifest (and offers "Install") for allowed users. Here we just register the service worker.
import { api } from "@/lib/api";

export const fetchPwaStatus = () => api.get("/pwa/status").then(({ data }) => !!data?.enabled).catch(() => false);

let registered = false;
export function registerServiceWorker() {
  if (registered || !("serviceWorker" in navigator) || process.env.NODE_ENV !== "production") return;   // caches the app shell + hashed assets only; /api is never cached
  registered = true;
  navigator.serviceWorker.register("/sw.js").then((reg) => {
    reg.addEventListener("updatefound", () => {
      const w = reg.installing;
      w?.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller) w.postMessage("skipWaiting"); });
    });
  }).catch(() => {});
  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => { if (!reloaded) { reloaded = true; window.location.reload(); } });
}
